import {IAuthResponse, IGenericResponse} from 'constants/interfaces';
const {encrypt: mainEncrypt, decrypt: mainDecrypt} = require('caesar-encrypt');
const ENCRYPTION_CONSTANT = 1;
enum ELshKeys {
  TOKEN = 'token',
  EMAIL = 'email',
  CART = 'cart',
}

const encrypt = (value: string) => mainEncrypt(value, ENCRYPTION_CONSTANT);
const decrypt = (value: string) => mainDecrypt(value, ENCRYPTION_CONSTANT);

const _storeData = (key: string, value: any) => {
  try {
    try {
      value = encrypt(JSON.stringify(value));
    } catch (error) {}
    localStorage.setItem(encrypt(key), value);
    return {success: true};
  } catch (error) {
    const e: any = error;
    return {success: false, ...e};
  }
};
const _retrieveData = (key: string) => {
  try {
    const value = localStorage.getItem(encrypt(key));
    if (value !== null) {
      return JSON.parse(decrypt(value));
    } else {
      return null;
    }
  } catch (error) {
    return error;
  }
};
const _removeData = async (key: string) => {
  try {
    await localStorage.removeItem(encrypt(key));
    return Promise.resolve({success: true});
  } catch (error) {
    return Promise.reject(error);
  }
};

export const STORAGE_ACTION = {_removeData, _retrieveData, _storeData};

/**
 * Save auth to local storage
 * @param {string} auth
 * @return {Promise}
 */
export function lshSAVEAUTH(auth: IAuthResponse): Promise<IGenericResponse> {
  return Promise.resolve(
    _storeData(ELshKeys.TOKEN, auth.token ? auth.token : ''),
  );
}

/**
 * Get the saved auth from local storage
 * @return {Promise}
 */
export function lshGETAUTH(): Promise<string> {
  return Promise.resolve(_retrieveData(ELshKeys.TOKEN) as string);
}

/**
 * Remove the saved auth from local storage
 * @return {Promise}
 */
export function lshREMOVEAUTH(): Promise<IAuthResponse> {
  return Promise.resolve(_removeData(ELshKeys.TOKEN));
}

/**
 * Save a user's email to local storage
 * @param {string} email
 * @return {Promise}
 */
export function lshSAVEEMAIL(email: string): Promise<IGenericResponse> {
  return Promise.resolve(_storeData(ELshKeys.EMAIL, email));
}
